import { IProxy } from '@copilot/common/store/models/redux';

export function createProxyLookup(proxies: IProxy[]): { [region: string]: number[] } {
    return proxies
        .sort((a, b) => a.name.localeCompare(b.name))
        .reduce(
            (acc, proxy) => {
                if (!acc[proxy.name]) {
                    acc[proxy.name] = [];
                }
                acc[proxy.name].push(proxy.value);
                return acc;
            },
            {} as { [region: string]: number[] }
        );
}
